"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-pier-d-isonzo": {
    "a75bb4fc": [{
      "hkey": "34ee04fa",
      "slug": "cassegliano-basegliano",
      "name": "Cassegliano-Basegliano",
      "primary": true,
      "skipSearch": false
    }],
    "cassegliano": [{
      "hkey": "34ee04fa",
      "slug": "cassegliano-basegliano",
      "name": "Cassegliano-Basegliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;